module.exports = __webpack_public_path__ + "static/azure-native-vms-2-2b4722b8229d461c1ae9d6134eb80db7.png";